import * as React from 'react';
import styled from 'styled-components';
import { TextInput } from '../../../../../../widgets/FormikInputFieldV2';
import { OBHardwareType } from '../../../../../../types';
import { HardwareModelSelect } from '../../../forms/HardwareModelSelect';
import { SiteSelect } from '../../../forms/SiteSelect';
import { useSelector } from 'react-redux';
import { sessionSelector } from '../../../../../../reducers/session';
import GenericSensorSelect from '../../../forms/generic-series/GenericSensorSelect';
import { useBeforeUnloadConfirmation } from '../../../../hooks/useBeforeUnloadConfirmation';
import { Input as UIKitInput } from '@rtkwlf/ui';
import {
  memoizedOnboardingSelectors,
  onboardingSelector,
} from '../../../../../../reducers/onboarding';
import onboardingUtils from '../../../../../../reducers/onboarding/utils';

const InputContainer = styled.div`
  max-width: 565px;
`;

type Props = {
  deviceType: 'Sensor' | 'Scanner';
  recommendedModel?: string;
};

export const InformationInputs: React.FunctionComponent<Props> = ({
  deviceType,
  recommendedModel,
}) => {
  useBeforeUnloadConfirmation(true);

  const genericSensorsEnabled = useSelector(
    onboardingSelector.showGenericSeries,
  );

  const isAwnUser = useSelector(sessionSelector.isAwnUser);

  const allAvailableModels = useSelector(
    memoizedOnboardingSelectors.getAvailableHardware,
  );

  const showGenericSeries = genericSensorsEnabled && deviceType === 'Sensor';

  let content;

  content = showGenericSeries ? (
    <GenericSensorSelect />
  ) : (
    <HardwareModelSelect
      type={
        deviceType === 'Sensor' ? OBHardwareType.SENSOR : OBHardwareType.SCANNER
      }
      currentId=""
    />
  );

  return (
    <InputContainer>
      <TextInput name="name" label={deviceType + ' Name'} required />
      {content}
      {showGenericSeries && recommendedModel && isAwnUser && (
        <UIKitInput
          className="mb-3"
          label="Recommended Model"
          value={
            onboardingUtils.getHardwareInfoByHardwareKey(
              allAvailableModels.sensors,
              recommendedModel,
            )?.label ?? recommendedModel
          }
          disabled
        />
      )}
      <SiteSelect name="siteId" id="selectSite" label="Site" required />
    </InputContainer>
  );
};
